import type { PurchaseCookieDto } from 'models/purchase'
import type { PageConfig } from 'models/pages'
import { getJsonSessionItem } from 'utils/session-storage'

export interface CampaignStats {
  donationAmountDefault?: number
  donationCurrencyDefault?: string
  donationFrequencyDefault?: string
  donationLocation?: string
  recurringNudge?: boolean
  donationOnetimeAmounts?: number[]
  donationRecurringAmounts?: number[]
}

export const buildMParticleDonationProperties = (
  pageConfig: PageConfig,
  purchaseCookie?: PurchaseCookieDto,
) => {
  // * Fetch campaign stats from session storage
  // * Persisting key values across applications for full funnel coverage
  const campaignStats = getJsonSessionItem<CampaignStats>(`campaign_${pageConfig.campaignId}_stats`)

  return {
    block_count: pageConfig.blockCount,
    donation_amount_default: campaignStats?.donationAmountDefault,
    donation_currency_default: campaignStats?.donationCurrencyDefault,
    donation_frequency_default: campaignStats?.donationFrequencyDefault,
    donation_location: campaignStats?.donationLocation,
    donation_recurring_nudge: campaignStats?.recurringNudge,
    donation_onetime_amounts: JSON.stringify(campaignStats?.donationOnetimeAmounts),
    donation_recurring_amounts: JSON.stringify(campaignStats?.donationRecurringAmounts),
    ...(purchaseCookie && {
      cover_transaction_fees_accepted: purchaseCookie.is_donor_covered_fee,
      donation_amount: purchaseCookie.raw_donation_gross_amount,
      donation_currency_default: purchaseCookie.currency_code,
      donation_currency: purchaseCookie.raw_currency_code,
      donation_frequency: purchaseCookie.frequency,
    }),
  }
}
